import PropTypes from 'prop-types';

import imageAssetShape from 'shapes/assetShape';

const { arrayOf, string, shape } = PropTypes;

export const cardShape = shape({
  title: string,
  icon: imageAssetShape,
  description: string,
  contentAlignment: string,
});

export default shape({
  sectionTitle: string,
  card: arrayOf(cardShape),
});
